"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    enable: Boolean,
    onLabel: String,
    offLabel: String
};